import { useState } from 'react';

export interface CategoryFilters {
  type: string;
  year: string;
  sort: string;
}

interface FilterBarProps {
  filters: CategoryFilters;
  years: string[];
  resultCount: number;
  onChange: (next: Partial<CategoryFilters>) => void;
  onReset: () => void;
}

const TYPES = ['全部', '电影', '美剧'];
const SORTS = ['综合排序', '评分从高到低', '评分从低到高', '最新更新'];

export default function FilterBar({
  filters,
  years,
  resultCount,
  onChange,
  onReset,
}: FilterBarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const selectCls =
    'px-3 py-2 rounded-md text-sm bg-background-50 border border-background-300 text-foreground-800 outline-none focus:border-primary-400 cursor-pointer';

  const Segmented = (
    <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/70">
      {TYPES.map((t) => (
        <button
          key={t}
          onClick={() => onChange({ type: t })}
          className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
            filters.type === t
              ? 'bg-primary-500 text-white'
              : 'text-foreground-600 hover:text-primary-600'
          }`}
        >
          {t}
        </button>
      ))}
    </div>
  );

  const Selects = (
    <div className="flex flex-wrap items-center gap-3">
      <select
        value={filters.year}
        onChange={(e) => onChange({ year: e.target.value })}
        className={selectCls}
        aria-label="年份筛选"
      >
        <option value="全部">全部年份</option>
        {years.map((y) => (
          <option key={y} value={y}>
            {y} 年
          </option>
        ))}
      </select>

      <select
        value={filters.sort}
        onChange={(e) => onChange({ sort: e.target.value })}
        className={selectCls}
        aria-label="排序方式"
      >
        {SORTS.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>

      <button
        onClick={onReset}
        className="flex items-center gap-1.5 px-3 py-2 rounded-md text-sm text-foreground-600 hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-refresh-line"></i> 重置筛选
      </button>
    </div>
  );

  return (
    <div className="rounded-lg bg-background-50 border border-background-200/70 p-4 md:p-5">
      <div className="hidden md:flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">{Segmented}</div>
        {Selects}
      </div>

      <div className="md:hidden">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          {Segmented}
          <button
            onClick={() => setMobileOpen((v) => !v)}
            className="flex items-center gap-1.5 px-3 py-2 rounded-md text-sm font-medium bg-secondary-100 text-secondary-900 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-filter-3-line"></i> 筛选
          </button>
        </div>
        {mobileOpen && <div className="mt-4 pt-4 border-t border-background-200">{Selects}</div>}
      </div>

      <div className="mt-4 text-xs text-foreground-500 flex items-center gap-1.5">
        <i className="ri-list-check"></i> 共找到 <strong className="text-primary-600">{resultCount}</strong> 部影视作品
      </div>
    </div>
  );
}